import axios from "axios";

console.log(process.VUE_APP_API_URL);
const server = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

export default server;
